<template>
<div class="container">
<br>
  <center>
    <h1> Oops, something went wrong!</h1>
    <hr>
  </center>
  <center>
  <br>
  <h4> It seems that our magic elves have made a mistake ...</h4>
  <h4>Our team has been alerted, and this issue will be fixed soon! We do apologize.</h4>
  </center>
  <br>
  <center>
    <h4>If this issue continues, or you have any other questions, please contact technical support at: <a href="mailto:scholarship@taphere.com">scholarship@taphere.com</a>.</h4>
    <h4>Please use the link below to return to the application.</h4>
  </center>
  <br>
  <center>
    <b-button href="#" class="btn btn-primary" @click="goBack"> Return to Previous Page</b-button>  
  </center>
  <hr>
</div>
</template>

<style lang="scss">
a.btn.bg-secondary.btn-primary{
  color:#FFFFFF;
}
</style>
<script>
  export default {
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.previousPath = from
      })
    },
    methods:{
      goBack() {
        let path = this.previousPath.path
        ///Use Regex to check path for two slashes to handle edge case -- two false params will be caught by '*' in routes, which will add another redirect, so need to go back 2 pages.
        if (path.match(/\//ig).length >= 2) {
          this.$router.go(-2) 
        } else {
          this.$router.go(-1)
        }
      },
    },

  }
</script>